import AdjustIcon from '@mui/icons-material/Adjust';
import { Box, Grid, Typography } from "@mui/material";
import moment from 'moment';
import { useEffect } from 'react';
import { getStatusProgessAPI } from '../../../api/url';
import { CheckStepper } from '../../../assets/images';
import { MuiStack } from '../../../components';
import StatusColor from '../../../components/atoms/statusColor';
import { useAppSelector } from '../../../store/hooks';
import { white } from '../../../theme/palette';
import { getStatusProgress } from '../apiCall';
import { StockTransferRequisitionAPIKeys } from '../entity';
export var StatusProgressComponent = function (props) {
    var _crud$StockTransferRe, _data$row, _data$row2;
    var data = props.data;
    var crud = useAppSelector(function (state) { return state.crud; });
    var statusProgress = ((_crud$StockTransferRe = crud[StockTransferRequisitionAPIKeys.statusProgress]) === null || _crud$StockTransferRe === void 0 ? void 0 : _crud$StockTransferRe.data) || [];
    var request = {
        ParentId: data === null || data === void 0 || (_data$row = data.row) === null || _data$row === void 0 ? void 0 : _data$row.id,
        EntityId: data === null || data === void 0 || (_data$row2 = data.row) === null || _data$row2 === void 0 ? void 0 : _data$row2.SchemaId
    };
    useEffect(function () {
        getStatusProgress({
            key: StockTransferRequisitionAPIKeys.statusProgress,
            request: request,
            url: getStatusProgessAPI
        });
    }, []);
    return /*#__PURE__*/ React.createElement(Box, {
        width: "100%"
    }, statusProgress.length > 0 ? statusProgress.map(function (step, index) { /*#__PURE__*/ return React.createElement(Grid, {
        container: true,
        spacing: 2,
        alignItems: "center",
        sx: {
            marginBottom: '8px'
        },
        key: index
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: "8px"
        }
    }, step.Key === "Approved" ? /*#__PURE__*/ React.createElement("img", {
        src: CheckStepper,
        alt: "Check Stepper",
        style: {
            width: '32px',
            height: '32px'
        }
    }) : /*#__PURE__*/ React.createElement(AdjustIcon, {
        color: step.Key === "Cancelled" ? "error" : "disabled",
        fontSize: "large"
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            marginTop: '5px',
            width: "2px",
            height: "60px",
            backgroundColor: '#dee4eb',
            marginBottom: "4px"
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary"
    }, moment(step.CreatedOn).format('DD MMM YYYY • h:mm A')), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: '#F4F7FA',
        borderRadius: '8px',
        padding: '10px',
        mt: '10px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        sx: {
            border: "1px solid #DEE4EB",
            borderRadius: "6px",
            columnGap: "5px",
            padding: "3px",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            bgcolor: white
        }
    }, /*#__PURE__*/ React.createElement(StatusColor, {
        status: step.Key
    }), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            width: 'max-content'
        },
        variant: "h6",
        id: "status-name"
    }, step.Key))))); }) : /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary"
    }, "No status progress available."));
};
